import styles from './team.module.scss'

function Team() {
    const previewSrc = `https://s.wordpress.com/mshots/v1/${encodeURIComponent('https://www.tudorulmeanu.co.uk/')}?w=800&h=500`;

    return (
        <div className={styles.team}>
            <div className={styles.label}>The team</div>
            <h2 className={styles.heading}>Meet the developer.</h2>

            <div className={styles.card}>
                <div className={styles.person}>
                    <div className={styles.avatar}>TU</div>
                    <div className={styles.info}>
                        <div className={styles.name}>Tudor Ulmeanu</div>
                        <div className={styles.title}>CEO &amp; Founder</div>
                    </div>
                    <p className={styles.bio}>
                        Full-stack developer and designer based in Manchester, UK.
                        Passionate about building fast, beautiful websites that help
                        businesses grow — from concept through to launch and beyond.
                    </p>
                    <a
                        className={styles.link}
                        href="https://www.tudorulmeanu.co.uk/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Visit portfolio
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                </div>

                <div className={styles.preview}>
                    <div className={styles.browserBar}>
                        <div className={styles.dots}>
                            <span className={styles.dot} />
                            <span className={styles.dot} />
                            <span className={styles.dot} />
                        </div>
                        <div className={styles.urlBar}>tudorulmeanu.co.uk</div>
                        <div className={styles.dotsSpacer} />
                    </div>
                    <div className={styles.previewImg}>
                        <img src={previewSrc} alt="Tudor Ulmeanu personal site" loading="lazy" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team
